import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { useLocaleContext } from '../../../context/LocaleContext';
import { Button } from '../../../design/css';
import { DetailRow } from '../../dashboardCommon';

const ViewOrderHeader = ({ orderData }) => {
  const locale = useLocaleContext();
  // All labels are fetched from EN.json and FR.json
  const {
    ORDERS: {
      orderId,
      businessName,
      channel,
      createdBy,
      createdAt,
      submittedDate,
      channelTicketNumber,
      spocTicketNumber,
      statusText
    },
    DEFECT_MANAGEMENT: { STATUS },
    formStep: { mssDefect }
  } = locale === 'en-US' ? EN : FR;
  const {
    orderId: orderIdvalue,
    wlsBusinessLegalName,
    channel: orderChannel,
    orderCreatedBy: { email },
    createdAt: createdAtValue,
    validatedAt: validatedAtValue,
    channelTicketNumber: channelTicketNumberValue,
    spocTicketNumber: spocTicketNumberValue,
    status: statusValue,
    reasonForSubmission,
    mssDefectTeam
  } = orderData;

  const getButton = (onClick, label, isDisabled) => (
    <Button onClick={onClick} disabled={isDisabled}>
      {label}
    </Button>
  );

  return (
    <Fragment>
      <DetailRow label={orderId} value={orderIdvalue} />
      <DetailRow label={businessName} value={wlsBusinessLegalName} />
      {orderChannel && orderChannel.description && (
        <DetailRow label={channel} value={orderChannel.description} />
      )}
      <DetailRow label={createdBy} value={email} />
      <DetailRow
        label={createdAt}
        value={
          moment.utc(createdAtValue).format('dddd, MMMM Do YYYY, h:mm:ss a') +
          ' UTC'
        }
      />
      {validatedAtValue && (
        <DetailRow
          label={submittedDate}
          value={
            moment
              .utc(validatedAtValue)
              .format('dddd, MMMM Do YYYY, h:mm:ss a') + ' UTC'
          }
        />
      )}
      <DetailRow label={STATUS} value={statusText[statusValue]} />
      {reasonForSubmission === mssDefect && mssDefectTeam === 'SMB Sales' && (
        <DetailRow label={channelTicketNumber} value={channelTicketNumberValue} />
      )}
      {reasonForSubmission === mssDefect && mssDefectTeam === 'BCX Care' && (
        <DetailRow label={spocTicketNumber} value={spocTicketNumberValue} />
      )}
    </Fragment>
  );
};

ViewOrderHeader.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default ViewOrderHeader;
